import { createSelector } from '@ngrx/store';

import { SearchBarState } from '@shared/base-search-bar/store/state/search-bar.state';
import { searchBarSelector } from '@shared/base-search-bar/store/selectors/search-bar.selector';

export const selectHourType = createSelector(
  searchBarSelector,
  (state: SearchBarState) => state.hourType
);
